export enum AcceptanceSource {
    Electronic = 0,
    Written = 1,
    Verbal = 2
}

export const AcceptanceSourceLabels: Record<AcceptanceSource, string> = {
    [AcceptanceSource.Electronic]: "Electronic",
    [AcceptanceSource.Written]: "Written",
    [AcceptanceSource.Verbal]: "Verbal"
};

export function getAcceptanceSourceLabel(source: AcceptanceSource): string {
    return AcceptanceSourceLabels[source] || "Unknown";
}

export function getSourceTypeOptions(): { value: AcceptanceSource; text: string }[] {
    return [
        { value: AcceptanceSource.Electronic, text: 'Electronic' },
        { value: AcceptanceSource.Written, text: 'Written' },
        { value: AcceptanceSource.Verbal, text: 'Verbal' }
    ];
}

export function getAcceptanceSourceBadgeVariant(source: AcceptanceSource): string {
    switch (source) {
        case AcceptanceSource.Electronic:
            return "primary";
        case AcceptanceSource.Written:
            return "success";
        case AcceptanceSource.Verbal:
            return "info";
        default:
            return "secondary";
    }
}
